import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import MobileStepper from '@mui/material/MobileStepper'
import { useContext } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import TooltipDialog from '../../components/dialog/tooltip/TooltipDialog'
import LinkPayment from '../../components/drawer/link/LinkPayment'
import Footer from '../../components/footer/Footer'
import { SimulatorProvider } from '../../context/SimulatorProvider'
import { StepperContext } from '../../context/StepperProvider'
import { VehicleProvider } from '../../context/VehicleProvider'
import SimulationMenu from '../simulation-menu/SimulationMenu'
import SimulationRecap from '../simulation-recap/SimulationRecap'
import StationAssetsForm from '../station-assets-form/StationAssetsForm'
import StationAssets from '../station-assets/StationAssets'
import VehicleProfile from '../vehicle-profile/VehicleProfile'
import './Simulator.css'
import StationInfos from './components/station-infos/StationInfos'
import VehicleInfos from './components/vehicle-infos/VehicleInfos'

function Simulator() {
  const { t } = useTranslation()
  const { nbSteps, currentStep, previousPage, nextPage, nextDisabled, previousDisabled } = useContext(StepperContext)
  const tutorialContent = [
    [t('tutorial.title'), <Trans i18nKey="tutorial.content-text1" />],
    [t('tutorial.title'), <Trans i18nKey="tutorial.content-text2" />, '/assets/illustration-2.svg'],
    [t('tutorial.title'), <Trans i18nKey="tutorial.content-text3" />, '/assets/illustration-3.svg'],
    [t('tutorial.title'), <Trans i18nKey="tutorial.content-text4" />],
    [t('tutorial.title'), <Trans i18nKey="tutorial.content-text5" />, '/assets/illustration-4.gif'],
    [t('tutorial.title2'), <Trans i18nKey="tutorial.content-text6" />],
    [t('tutorial.title3'), <Trans i18nKey="tutorial.content-text7" />]
  ]

  const renderStepContent = (step: number) => {
    switch (step) {
      case 0:
        return <StationAssetsForm />
      case 1:
        return <VehicleProfile />
      case 2:
        return <SimulationMenu />
      case 3:
        return <StationAssets />
      case 4:
        return <SimulationRecap />
      default:
        return <div>Page not found</div>
    }
  }

  return (
    <>
      <Container maxWidth="xs" className="main-container">
        <div className="simulator-container">
          <SimulatorProvider>
            <VehicleProvider>
              {currentStep >= 1 && <StationInfos />}
              {currentStep >= 2 && <VehicleInfos />}
              {renderStepContent(currentStep)}
            </VehicleProvider>
          </SimulatorProvider>
        </div>
        <div className="footer-container">
          <MobileStepper
            variant="dots"
            steps={nbSteps + 1}
            position="static"
            activeStep={currentStep}
            nextButton={
              currentStep === nbSteps ? (
                <TooltipDialog
                  button={
                    <div className="tooltip-button">
                      <KeyboardArrowRight />
                      <div>{t('mobile-stepper.tutorial-button')}</div>
                    </div>
                  }
                  content={tutorialContent}
                  steps={7}
                />
              ) : (
                <Button color="secondary" size="small" onClick={nextPage} disabled={nextDisabled}>
                  <KeyboardArrowRight />
                  {t('mobile-stepper.next')}
                </Button>
              )
            }
            backButton={
              <Button color="secondary" size="small" onClick={previousPage} disabled={previousDisabled}>
                {t('mobile-stepper.previous')}
                <KeyboardArrowLeft />
              </Button>
            }
          />
          <Footer />
        </div>
        {currentStep === 0 && <LinkPayment />}
      </Container>
    </>
  )
}

export default Simulator
